export default "__VITE_ASSET__Qsvjh7m$__"